export const domainNames = {
    policy_site: `policy.charter.com`,
    corporate_site: `corporate.charter.com`,
};
export const addDomainName = (isPolicy: boolean): string =>
    isPolicy ? domainNames.policy_site : domainNames.corporate_site;
